import $ from 'jquery';

$(function () {
    /** Detect if element was focused through keyboard navigation */
    let hadKeyboardEvent = false;
    const onKeyDown = (e) => {
        if (e.metaKey || e.altKey || e.ctrlKey) {
            return;
        }
        hadKeyboardEvent = true;
    };
    const onPointerDown = () => {
        hadKeyboardEvent = false;
    };

    /** CSS selectors to assign .keyboard-focus to specified elements when
     * navigating over them using a keyboard. */
    const targetSelectors = 'button, .navbar-toggler, input, a.btn, .wp-block-button__link';

    $(document).on('focus', targetSelectors, function (e) {
        if (hadKeyboardEvent) {
            $(this).addClass('keyboard-focus');
        }
    });

    $(document).on('blur', targetSelectors, function (e) {
        $(this).removeClass('keyboard-focus');
    });

    /** Attach keyboard and pointer event listeners */
    $(document).on('keydown', onKeyDown);
    $(document).on('mousedown', onPointerDown);
    $(document).on('pointerdown', onPointerDown);
    $(document).on('touchstart', onPointerDown);
});
